import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigurationStartComponent} from './configuration-start/configuration-start.component';
import {RouterModule} from "@angular/router";
import {ComponentsModule} from "../../../components/components.module";
import {PipeModule} from "../../../pipe/pipe.module";
import {NxCardModule} from "@allianz/ng-aquila/card";
import {NxGridModule} from "@allianz/ng-aquila/grid";
import {TranslateModule} from "@ngx-translate/core";
import {NxTableModule} from "@allianz/ng-aquila/table";
import {NxLinkModule} from "@allianz/ng-aquila/link";
import {NxBadgeModule} from "@allianz/ng-aquila/badge";
import {NxProgressbarModule} from "@allianz/ng-aquila/progressbar";
import {NxTooltipModule} from "@allianz/ng-aquila/tooltip";
import {NxHeadlineModule} from "@allianz/ng-aquila/headline";
import {NxTabsModule} from "@allianz/ng-aquila/tabs";
import {NxFormfieldModule} from "@allianz/ng-aquila/formfield";
import {NxDropdownModule} from "@allianz/ng-aquila/dropdown";
import {FormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    ConfigurationStartComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    PipeModule,
    NxCardModule,
    NxGridModule,
    TranslateModule,
    NxTableModule,
    NxLinkModule,
    NxBadgeModule,
    NxProgressbarModule,
    NxTooltipModule,
    NxHeadlineModule,
    NxTabsModule,
    NxFormfieldModule,
    NxDropdownModule,
    FormsModule,
  ]
})
export class ConfigurationModule {
}
